import React from 'react'

export default function Loading() {
  return (
    <div id='loading'>
      <section className='loading-section'>
        <h2 className='loading-text'>Loading...</h2>
      </section>
    </div>
  )
}
